<template>
	<div>
		<template v-if="roleRules.FEES_FLG === 'Y'">
			<div class="instructions alert alert-info"
						v-html="headerText"
						v-if="roleRules.FEES_DESCRIPTION_FLG === 'Y' && headerText.length > 0"
			/>
			<h2 tabindex="0" v-if="district.CWP_ALLOW_PAYMENTS_FLG == 'N'">
				{{ $t('MAIN_CONTENT.Fees.balanceOwed', { fee: '' } ) }} <span :class="{'text-danger': totalBalanceOwed > 0}">{{$options.filters.dollar(totalBalanceOwed)}}</span>
			</h2>
			<payment-portal :balance="totalBalanceOwed" @paid="loadFees()" v-if="district.CWP_ALLOW_PAYMENTS_FLG == 'Y'"/>
			<div class="row" v-if="district.CWP_ALLOW_PAYMENTS_FLG == 'N'">
				<div class="col-xs-12">
					<sapphire-toggle
						class="col-xs-6 col-md-4 col-lg-3"
						v-model="useAllSchoolYears"
						:label="$t( 'MAIN_CONTENT.Fees.showAllSchoolYears' )"
						:ariaLabel="$t( 'MAIN_CONTENT.Fees.showAllSchoolYears' )"
					/>
				</div>
			</div>
			<div class="table-responsive" v-if="feesData.length > 0 && district.CWP_ALLOW_PAYMENTS_FLG == 'N'">
				<table-editable-list
					:columns="columns"
					:show-select="false"
					:show-actions="false"
					headerClasses="text-left"
				>
					<template slot="data-row">
						<template v-for="(fee, feeIdx) in feesData">
							<table-list-row
								:key="`fee-${fee.TRANS_ID}`"
								:columns="columns"
								:rowdata="fee"
								:rowIndex="feeIdx"
								:showActions="false"
							>
							</table-list-row>
						</template>
					</template>
				</table-editable-list>
			</div>
		</template>
		<template v-else>
			{{ $t('MAIN_CONTENT.commonContent.invalidPermissions') }}
		</template>
	</div>
</template>

<script>
	import Fees from '../api/Fees';
	import FeesHeader from '../api/FeesHeader';

	import { mapGetters } from 'vuex';
	import moment from 'moment';

	import TableEditableList from 'COMMONS/tables/TableEditableList.vue';
	import TableListRow from 'COMMONS/tables/TableListRow.vue';
	import SapphireToggle from 'COMMONS/SapphireToggle/SapphireToggle.vue';

	import PaymentPortal from './PaymentPortal.vue';
	import DistrictImage from '../api/DistrictImage';

	export default {
		data() {
			return {
				isLoading: {
					settings: false
				},
				headerText: '',
				selectedColumns: [],
				showHideColumns: [],
				sortOrders: {},
				feesData: [],
				totalBalanceOwed: 0,
				useAllSchoolYears: false,
				district: {},
			}
		},
		computed: {
			...mapGetters(['selectedStudent', 'roleRules']),
			columns() {
				return [
					{
						heading: this.$t( 'MAIN_CONTENT.Fees.date' ),
						key: 'TRANS_DATE',
						customCol: 'date'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.Fees.type' ),
						key: 'STUD_FEE_CAT_DESC',
						customCol: 'type'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.Fees.fee' ),
						key: 'FEE_AMOUNT',
						customCol: 'fee'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.Fees.payment' ),
						key: 'PAYMENT_AMOUNT',
						customCol: 'payment'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.Fees.balanceOwed' ),
						key: 'BALANCE',
						customCol: 'balance'
					}
				];
			},
		},
		components: {
			SapphireToggle,
			TableEditableList,
			TableListRow,
			PaymentPortal,
		},
		methods: {
			loadSettings() {
				this.isLoading.settings = true;
			},
			getDistrictImage() {
				const self = this;
				const district = new DistrictImage({});
				const promise = district.get();
				promise.then(response => {
					self.$set(self, 'district', district.getResponseData());
				});
			},
			loadFees( useAllSchoolYears = false ) {
				const self = this;

				let fees = new Fees({
					route: 'fees',
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
						useAllSchoolYears: useAllSchoolYears
					}
				});

				const promise = fees.get();

				promise.then(response => {
					self.$set(self, 'feesData', response.data.data);
					let balance = 0;

					for(let d in self.feesData) {
						let fee = self.feesData[d];

						fee.FEE_AMOUNT = "";
						fee.PAYMENT_AMOUNT = "";

						if( fee.TRANS_TYPE === 'FEE' || fee.TRANS_TYPE === 'REFUND' ) {
							fee.FEE_AMOUNT = self.$options.filters.dollar(fee.TRANS_AMOUNT);
						}
						if( fee.TRANS_TYPE === 'DEPOSIT' || fee.TRANS_TYPE === 'PAYMENT' ) {
							fee.PAYMENT_AMOUNT = self.$options.filters.dollar(Math.abs(fee.TRANS_AMOUNT));
						}

						fee.TRANS_DATE = moment(fee.TRANS_DATE).format('MM/DD/YYYY');
						balance += +fee.TRANS_AMOUNT;

						self.$set(fee, 'BALANCE', self.$options.filters.dollar(balance));
						fee.TRANS_AMOUNT = self.$options.filters.dollar(fee.TRANS_AMOUNT);

						
					}
					self.feesData = self.feesData.reverse();
					self.loadBalance();
				})
				.catch(error => {
					console.log(error);
				});
			},
			loadBalance() {
				const self = this;

				let fees = new Fees({
					route: 'fees/balance',
					query: {
						student_rid: this.selectedStudent.STUDENT_RID
					}
				});

				const promise = fees.get();

				promise.then(response => {
					self.$set(self, 'totalBalanceOwed', response.data.data);
				})
				.catch(error => {
					console.log(error);
				});
			},
			getBalancedOwed(id) {
				let balanceOwed = 0;

				for(let f in this.feeData) {
					let fee = this.feeData[f];

					if(+fee.TRANS_ID === +id) {
						balanceOwed += fee.TRANS_AMOUNT;
						break;
					}

					balanceOwed += fee.TRANS_AMOUNT;
				}

				return balanceOwed;
			},
			loadHeader() {
				const self = this;

				let header = new FeesHeader({
					query: {
						student_rid: this.selectedStudent.STUDENT_RID
					}
				});

				const promise = header.get();

				promise.then( response => {
					if( header.getResponseData().length > 0 ) {
						self.headerText = header.getResponseData();
					}
				})
				.catch(error => {
					console.log(error);
				});
			},
		},
		watch: {
			useAllSchoolYears( newValue, oldValue ) {
				if( newValue !== oldValue ) {
					this.loadFees( newValue );
				}
			}
		},
		created() {
			this.$store.commit('setTitleIcon', 'dollar-sign');
			this.$store.commit('setTitle', 'MAIN_CONTENT.Fees.sideMenuFeesLink');
			this.$store.commit('setUseHeader', true);
			this.getDistrictImage();
			if(this.roleRules.FEES_FLG === 'Y') {
				this.loadHeader();
				this.loadFees();
			} else {
				this.$router.push({ name: 'HomePage' });
			}
		}
	}
</script>
